module.exports = __webpack_public_path__ + "img/03-flower-line-L.0ab5d520.png";